export const getShowingTimeOnly = (startTime: string | Date, endTime: string | Date): string => {
  const startTimePart = new Date(startTime).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });

  const endTimePart = new Date(endTime).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${startTimePart} - ${endTimePart}`;
};
